export default __webpack_public_path__ + "static/media/Girdle of Blind Devotion.0f60d40e.jpg";